import { AtMentionsViewState } from '../store/schema/AtMentionsViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('removeMentionAddedRecipient')(function removeMentionAddedRecipient(
    viewState: AtMentionsViewState,
    indexToRemove: number
) {
    viewState.mentionsAddedRecipients.splice(indexToRemove, 1);
});
